import { createGlobalStyle } from 'styled-components';

const FontsStyles = createGlobalStyle`
  @font-face {
    font-family: Handjet;
    src: url('/fonts/handjet.woff2') format('woff2');
    font-weight: 100 900;
    font-display: swap;
    font-style: normal;
  }
`;

export { FontsStyles };
